export default __webpack_public_path__ + "static/media/NanumSquareEB.e5471443.ttf";